import { render, staticRenderFns } from "./PcAov.vue?vue&type=template&id=6157a63e&scoped=true&lang=pug&"
import script from "./PcAov.vue?vue&type=script&lang=js&"
export * from "./PcAov.vue?vue&type=script&lang=js&"
import style0 from "./PcAov.vue?vue&type=style&index=0&id=6157a63e&lang=sass&scoped=true&"
import style1 from "./PcAov.vue?vue&type=style&index=1&id=6157a63e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6157a63e",
  null
  
)

export default component.exports